<template>
  <div>
    <b-container>
      <b-card style="height: 500px">
          <apexchart
              width="80%"
              type="bar"
              :options="options"
              :series="series"
              style="margin-left: 200px;"></apexchart>
      </b-card>
    </b-container>
  </div>
</template>

<script>


export default {
  name: "LineChart",
  props: {
    byPosition:{
      required: true,
    }
  },
  data: function() {
    return {
      options: {
        chart: {
          id: 'vuechart-example'
        },
        xaxis: {
          categories: ["Maktab o'qituvchisi",
            "Fizika o'qituvchisi",
            "Jismoniy Tarbiya o'qituvchisi",
            "Ingliz tili o'qituvchisi"]
        }
      },
      series: [{
        name: 'series-1',
        data: [40, 35, 22, 18, ]
      }]
    }
  },
  watch: {
    byPosition: {
      immediate: true,
      handler() {
        if(this.byPosition.length) {
          let series = [];
          let labels = [];
          this.byPosition.forEach(item => {
            series.push(item.count);
            labels.push(item.label);
          })
          // eslint-disable-next-line no-console
          console.log(this.byPosition)
          this.options = {...this.options,...{xaxis:{categories: labels}}};
          this.series = [{data: series}]
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
